/**
 *
 * This file was generated with Adobe XD React Exporter
 * Exporter for Adobe XD is written by: Johannes Pichler <j.pichler@webpixels.at>
 *
 **/
import React, { useEffect, useState } from "react";

const PagedAttenteWebComponent = () => {

  const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
  });
   useEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  return (
    <>
      {size.width > 768 ? (<svg width={size.width} height={size.height} viewBox="0 0 1920 1080">
        <defs>
          <style>
            {
              ".a{clip-path:url(#c);}.b{fill:url(#a);}.c{fill:#707070;font-size:28px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.d{fill:#fff;}.e{fill:#fff;}"
            }
          </style>
          <pattern
            id="a"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 1064 358"
          >
            <image width={1064} height={358} xlinkHref="logo.png" />
          </pattern>
          <clipPath id="c">
            <rect width={1920} height={1080} />
          </clipPath>
        </defs>
        <g id="b" className="a">
          <rect className="e" width={1920} height={1080} />
          <rect
            className="b"
            width={836}
            height={282}
            transform="translate(542 399)"
          />
          <text className="c" transform="translate(726 775)">
            <tspan x={0} y={0}>
              {"Votre futur alli\xE9 beaut\xE9 arrive bient\xF4t\u2026"}
            </tspan>
          </text>
          <a href="https://www.instagram.com/onfleek_reunion/">
            <rect
              className="d"
              width={33}
              height={35}
              transform="translate(960 865)"
            />
          </a>
          <path
            d="M16.627,10.764A8.744,8.744,0,0,0,8.1,19.738a8.744,8.744,0,0,0,8.525,8.974,8.744,8.744,0,0,0,8.525-8.974A8.744,8.744,0,0,0,16.627,10.764Zm0,14.808a5.7,5.7,0,0,1-5.542-5.834A5.7,5.7,0,0,1,16.627,13.9a5.7,5.7,0,0,1,5.542,5.834,5.7,5.7,0,0,1-5.542,5.834ZM27.49,10.4a1.991,1.991,0,1,1-3.977,0,1.991,1.991,0,1,1,3.977,0Zm5.646,2.124c-.126-2.8-.735-5.287-2.686-7.333a9.635,9.635,0,0,0-6.967-2.827C20.738,2.2,12.51,2.2,9.764,2.361A9.62,9.62,0,0,0,2.8,5.18C.846,7.226.245,9.71.112,12.514c-.156,2.89-.156,11.551,0,14.44.126,2.8.735,5.287,2.686,7.333a9.647,9.647,0,0,0,6.967,2.827c2.745.164,10.973.164,13.719,0a9.572,9.572,0,0,0,6.967-2.827c1.944-2.046,2.552-4.53,2.686-7.333.156-2.89.156-11.543,0-14.433ZM29.589,30.055a5.767,5.767,0,0,1-3.161,3.327c-2.189.914-7.382.7-9.8.7s-7.62.2-9.8-.7a5.767,5.767,0,0,1-3.161-3.327C2.8,27.751,3,22.284,3,19.738S2.8,11.717,3.666,9.421A5.767,5.767,0,0,1,6.826,6.094c2.189-.914,7.382-.7,9.8-.7s7.62-.2,9.8.7a5.767,5.767,0,0,1,3.161,3.327c.868,2.3.668,7.771.668,10.317S30.457,27.758,29.589,30.055Z"
            transform="translate(960.005 863.056)"
          />
          <a href="https://www.facebook.com/On-Fleek-100488315825901">
            <rect
              className="d"
              width={33}
              height={35}
              transform="translate(915 865)"
            />
          </a>
          <path
            d="M18.251,19.688l.923-6.334H13.4V9.243a3.092,3.092,0,0,1,3.393-3.422h2.625V.428A30.461,30.461,0,0,0,14.758,0C10,0,6.9,3.034,6.9,8.526v4.828H1.609v6.334H6.9V35H13.4V19.688Z"
            transform="translate(920.986 865)"
          />
        </g>
      </svg>) : (
  
  
        <svg width={size.width} height={size.height} viewBox="0 0 1080 1920">
          <defs>
            <style>
              {
                ".a{clip-path:url(#c);}.b{fill:url(#a);}.c{fill:#707070;font-size:28px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.d{fill:#fff;}"
              }
            </style>
            <pattern
              id="a"
              preserveAspectRatio="none"
              width="100%"
              height="100%"
              viewBox="0 0 1064 358"
            >
              <image width={1064} height={358} xlinkHref="logo.png" />
            </pattern>
            <clipPath id="c">
              <rect width={1080} height={1920} />
            </clipPath>
          </defs>
          <g id="b" className="a">
            <rect className="d" width={1080} height={1920} />
            <rect
              className="b"
              width={836}
              height={282}
              transform="translate(122 709.353)"
            />
            <text className="c" transform="translate(306 1085.353)">
              <tspan x={0} y={0}>
                {"Votre futur alli\xE9 beaut\xE9 arrive bient\xF4t\u2026"}
              </tspan>
            </text>
            <a href="https://www.instagram.com/onfleek_reunion/">
              <rect
                className="d"
                width={33}
                height={35}
                transform="translate(545.871 1786)"
              />
            </a>
            <path
              d="M16.627,10.764A8.744,8.744,0,0,0,8.1,19.738a8.744,8.744,0,0,0,8.525,8.974,8.744,8.744,0,0,0,8.525-8.974A8.744,8.744,0,0,0,16.627,10.764Zm0,14.808a5.7,5.7,0,0,1-5.542-5.834A5.7,5.7,0,0,1,16.627,13.9a5.7,5.7,0,0,1,5.542,5.834,5.7,5.7,0,0,1-5.542,5.834ZM27.49,10.4a1.991,1.991,0,1,1-3.977,0,1.991,1.991,0,1,1,3.977,0Zm5.646,2.124c-.126-2.8-.735-5.287-2.686-7.333a9.635,9.635,0,0,0-6.967-2.827C20.738,2.2,12.51,2.2,9.764,2.361A9.62,9.62,0,0,0,2.8,5.18C.846,7.226.245,9.71.112,12.514c-.156,2.89-.156,11.551,0,14.44.126,2.8.735,5.287,2.686,7.333a9.647,9.647,0,0,0,6.967,2.827c2.745.164,10.973.164,13.719,0a9.572,9.572,0,0,0,6.967-2.827c1.944-2.046,2.552-4.53,2.686-7.333.156-2.89.156-11.543,0-14.433ZM29.589,30.055a5.767,5.767,0,0,1-3.161,3.327c-2.189.914-7.382.7-9.8.7s-7.62.2-9.8-.7a5.767,5.767,0,0,1-3.161-3.327C2.8,27.751,3,22.284,3,19.738S2.8,11.717,3.666,9.421A5.767,5.767,0,0,1,6.826,6.094c2.189-.914,7.382-.7,9.8-.7s7.62-.2,9.8.7a5.767,5.767,0,0,1,3.161,3.327c.868,2.3.668,7.771.668,10.317S30.457,27.758,29.589,30.055Z"
              transform="translate(545.876 1784.056)"
            />
            <a href="https://www.facebook.com/On-Fleek-100488315825901">
              <rect
                className="d"
                width={33}
                height={35}
                transform="translate(500.871 1786)"
              />
            </a>
            <path
              d="M18.251,19.688l.923-6.334H13.4V9.243a3.092,3.092,0,0,1,3.393-3.422h2.625V.428A30.461,30.461,0,0,0,14.758,0C10,0,6.9,3.034,6.9,8.526v4.828H1.609v6.334H6.9V35H13.4V19.688Z"
              transform="translate(506.857 1786)"
            />
          </g>
        </svg>
      )}
    </>
  
  )
}

export default PagedAttenteWebComponent;
